import React from "react"
// import { Link } from "gatsby";
import { css } from "styled-components"
import Layout from "../layouts/layout"
// import Image from "../components/image";
import Seo from "../components/seo"
import { UiText, Heading } from "../components"
const AboutPage = () => (
  <Layout>
    <Seo title="About" />
    <div
      css={css`
        position: relative;
        max-width: 960px;
        margin: auto;
        padding: 40px 0px;
      `}
    >
      <Heading level={1} as="h1" variant="h1">
        About Me
      </Heading>

      <UiText variant="content">
        Hi, my name is Souleymane Dembele, a computer/hardware engineer working
        across the full hardware stack. I design transistor-level RF and analog
        ICs, write RTL for FPGA accelerators, study computer architecture, and
        build embedded firmware with custom RTOS and control systems. I am
        completing my MS in Electrical and Computer Engineering at the University
        of Washington Tacoma, where my thesis is a custom GEMM accelerator on a
        Cyclone V SoC, taken from RTL through to a full Linux bring-up. Recent
        work spans a CMOS power amplifier in TSMC 0.18um RF CMOS, an FPGA NES
        emulator, a three-level cache simulator, and a quadcopter flight
        controller on an STM32. My years of experience as a software engineer gave me the
        systems discipline I bring to hardware. I still build software when a
        project needs it, but hardware is the center of my work. My wife and I
        live in the Greater Seattle Area.
      </UiText>
      <Heading level={2} as="h2" variant="h2">
        Hardware Design
      </Heading>
      <dl>
        <UiText as="dt" variant="contentBold">
          Hardware Description Languages (HDL)
        </UiText>
        <UiText as="dd">Verilog • SystemVerilog • VHDL</UiText>
        <UiText as="dt" variant="contentBold">
          FPGA / Dev Boards
        </UiText>
        <UiText as="dd">
          Intel/Altera: Terasic SoCKit Cyclone V SoC (5CSXFC6D6) • Terasic
          DE2-115 Cyclone IV • Xilinx: Digilent Basys 3 Artix-7
        </UiText>
        <UiText as="dt" variant="contentBold">
          Microcontrollers
        </UiText>
        <UiText as="dd">
          STM32F4 (F405/F411) • TI Tiva TM4C • ESP32 • Raspberry Pi and Pi Pico
          RP2040/RP2350 • Arduino
        </UiText>
        <UiText as="dt" variant="contentBold">
          Microprocessors
        </UiText>
        <UiText as="dd">
          Arm Cortex-A9 (Cyclone V HPS) • Arm Cortex-M4 • Arm Cortex-M0 •
          ARM7TDMI • Atmega328
        </UiText>
      </dl>
      <Heading level={2} as="h2" variant="h2">
        EDA, Simulation, and CAD/CAM
      </Heading>
      <dl>
        <UiText as="dt" variant="contentBold">
          Electronic Design Automation (EDA)
        </UiText>
        <UiText as="dd">
          Cadence Virtuoso • Cadence SpectreRF • Calibre (DRC/LVS) • Quartus
          Prime • Qsys/Platform Designer • ModelSim • Xilinx Vivado/ISE •
          Synopsys
        </UiText>
        <UiText as="dt" variant="contentBold">
          Circuit Simulation
        </UiText>
        <UiText as="dd">
          Cadence Spectre/SpectreRF (PSS, PAC, load-pull) • LTSpice • Logisim
          Evolution
        </UiText>
        <UiText as="dt" variant="contentBold">
          Computer-Aided Design (CAD)
        </UiText>
        <UiText as="dd">
          KiCad • Altium Designer • Fusion 360 • Autodesk Eagle • FlatCam
        </UiText>
        <UiText as="dt" variant="contentBold">
          Computer-Aided Manufacturing (CAM)
        </UiText>
        <UiText as="dd">
          CNC machining (subtractive) • 3D printing (additive)
        </UiText>
      </dl>
      <Heading level={2} as="h2" variant="h2">
        Software
      </Heading>
      <dl>
        <UiText as="dt" variant="contentBold">
          Languages
        </UiText>
        <UiText as="dd">
          C • C++ • ARM Assembly • RISC-V Assembly • MIPS Assembly • x86-64
          Assembly • Python • MATLAB • JavaScript • Git • LaTeX
        </UiText>
        <UiText as="dt" variant="contentBold">
          Frameworks and Libraries
        </UiText>
        <UiText as="dd">
          Qt • JUCE • Django • Spring • React • Redux • NumPy • Scikit-learn •
          Pandas • Matplotlib • SciPy • SDL2
        </UiText>
        <UiText as="dt" variant="contentBold">
          Databases
        </UiText>
        <UiText as="dd">MySQL • PostgreSQL</UiText>
      </dl>
      <Heading level={2} as="h2" variant="h2">
        Hobbies
      </Heading>
      <UiText as="ul">
        <UiText as="li">✅ Learning</UiText>
        <UiText as="li">✅ Spend time with family</UiText>
        <UiText as="li">✅ Traveling</UiText>
        <UiText as="li">✅ TV • Video Game • Anime(Manga)</UiText>
      </UiText>
    </div>
  </Layout>
)

export default AboutPage
